import React from 'react';
import styled from 'styled-components';

import * as CatizColor from './Colors';

const ButtonContainer = styled.button`
  background-color: ${CatizColor.blue};
  color: ${CatizColor.fontColor};
  border-radius: 10%;
`;

export default function Button({ children }: { children: React.ReactNode }) {
  return <ButtonContainer>{children}</ButtonContainer>;
}
